export default {
  image: 'Imagen',
  clickToExpandImage: 'Click para expandir imagen',
  viewImageOptions: 'Ver opciones de imagen',
  alignLeft: 'Alinear a la izquierda',
  center: 'Centrar',
  alignRight: 'Alinear a la derecha',
  alignTop: 'Alinear arriba',
  alignBottom: 'Alinear abajo',
  changeImage: 'Cambiar imagen',
  deleteImage: 'Eliminar imagen',
  selectOrDragImageHere: 'Seleccione o arrastre la imagen aquí...',
  dragImageHere: 'Arrastre la imagen aquí...',
  imageDeletedSuccessfully: 'Imagen eliminada.',
}
